module.exports = __webpack_public_path__ + "static/media/calculator.de800a43.png";